import Api from "@/services/api";
import {
	LOAD_LOGS,
	REMOVE_LOG,
	ADD_ALERT,
	REMOVE_LOGS,
} from "@/store/_actiontypes";
import { DELETE_LOG, SET_LOG } from "@/store/_mutationtypes";

const state = {
	loglist: [],
};

const actions = {
	[LOAD_LOGS]({ commit }) {
		Api.get("/log").then((response) => {
			let value = response.data;
			commit(SET_LOG, value);
		});
	},
	[REMOVE_LOG]({ commit, dispatch }, { id }) {
		Api.delete(`/log/${id}`).then(() => {
			commit(DELETE_LOG, id);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Log deleted successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_LOGS]({ commit, dispatch }, { ids }) {
		let deletedCount = 0;

		const updateProgress = () => {
			dispatch(
				`alert/${ADD_ALERT}`,
				{
					message: `Deleting ${deletedCount}/${ids.length} logs...`,
					color: "info",
				},
				{ root: true }
			);
		};

		const deletedLogs = ids.map((id) => {
			return Api.delete(`/log/${id}`).then(() => {
				commit(REMOVE_LOG, id);
				deletedCount++;
				updateProgress();
			});
		});

		Promise.all(deletedLogs)
			.then(() => {
				dispatch(
					`alert/${ADD_ALERT}`,
					{
						message: `Successfully deleted ${ids.length} logs`,
						color: "success",
					},
					{ root: true }
				);
			})
			.catch((error) => {
				console.error("Error deleting logs:", error);
			});
	},
};

const mutations = {
	[SET_LOG](state, value) {
		state.loglist = value;
	},
	[DELETE_LOG](state, id) {
		state.loglist = state.loglist.filter((h) => h.id != id);
	},
};

export const logs = {
	namespaced: true,
	state,
	actions,
	mutations,
};
